<template>
  <Base
    ref="base"
    :on-submit="(params) => api.template.update(params, this.$route.params.id)"
    :on-get="(id) => api.template.getById(id)"
    :triger-prevent="trigerPrevent"
    field-details-route="field-details"
    templates-route="templates"
    :is-ticket="true"
  />
</template>

<script>
import { mapActions } from 'vuex';
import api from '../../../../api/index';

import Base from '../base/base-edit';

import { beforeRouteLeaveFunction } from '../base/common';

export default {
  title: 'EditTicketTemplate',
  components: { Base },
  beforeRouteLeave(to, from, next) {
    const changed = this.$refs.base.exit();
    return beforeRouteLeaveFunction(to, from, next, this.disablePrevent, this.$translate, changed, this.clearTemplates);
  },
  data() {
    return {
      api: api,
      disablePrevent: false,
    };
  },
  ...mapActions({ clearTemplates: 'template/clearTemplates' }),
  methods: {
    trigerPrevent: function (value) {
      this.disablePrevent = value;
    },
  },
};
</script>
